export default {
  root: ({ props }) => ({
    class: [
      'relative',

      // Flex
      'inline-flex',

      // Size
      { 'w-full': props.multiple },

      // Color
      'text-surface-0',

      //States
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled
      }
    ]
  }),
  container: ({ props, state }) => ({
    class: [
      // Font
      'font-sans text-base leading-none',

      // Flex
      'flex items-center flex-wrap',
      'gap-2',

      // Spacing
      'm-0 list-none',
      'px-2',

      // Size
      'w-full',
      'min-h-[2.877rem]',

      // Shape
      'appearance-none',

      // Color
      'text-white/80',
      'placeholder:text-surface-500',
      'bg-surface-900',
      'border border-surface-700',

      // States
      'hover:border-primary-400',
      'focus:outline-hidden focus:outline-offset-0',
      { 'ring-3 ring-primary-300/50': state.focused },
      { 'ring-3 ring-primary-300/50': state.hovered },
      // Transition
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-text overflow-hidden'
    ]
  }),
  inputtoken: {
    class: ['py-1.5 px-0', 'inline-flex flex-auto']
  },
  input: ({ props }) => ({
    class: [
      // Font
      'font-sans text-base leading-none',

      // Shape
      'appearance-none',
      { 'outline-hidden shadow-none': props.multiple },

      // Size
      { 'w-full': props.multiple },

      // Spacing
      'm-0',
      { 'p-3': !props.multiple, 'p-0': props.multiple },

      // Colors
      'text-white/80',
      {
        'bg-surface-900': !props.multiple,
        'border border-surface-700': !props.multiple,
        'border-0 bg-transparent': props.multiple
      },

      // States
      {
        'focus:outline-hidden focus:outline-offset-0 focus:ring-3 focus:ring-primary-300/50':
          !props.multiple
      },

      // Transition
      'transition-colors duration-200'
    ]
  }),
  token: {
    class: [
      // Flex
      'inline-flex items-center',

      // Spacings
      'py-1.5 px-3',

      // Shape
      'rounded-[1.14rem]',

      // Colors
      'bg-surface-700',
      'text-white/70',

      // Misc
      'cursor-default'
    ]
  },
  label: {
    class: 'leading-5'
  },
  removeTokenIcon: {
    class: [
      // Shape
      'rounded-md leading-6',

      // Spacing
      'ml-2',

      // Size
      'w-4 h-4',

      // Transition
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-pointer'
    ]
  },
  dropdownbutton: {
    root: {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom',

        // Size
        'px-4 py-3 leading-none',

        // Colors
        'text-surface-900',
        'bg-primary-400',
        'border border-primary-400',

        // States
        'focus:outline-hidden focus:outline-offset-0 focus:ring-3',
        'hover:bg-primary-300 hover:border-primary-300',
        'focus:ring-primary-300/50'
      ]
    }
  },
  loadingicon: {
    class: ['text-surface-0/70', 'absolute top-[50%] right-[0.5rem] -mt-2 animate-spin']
  },
  panel: {
    class: [
      // Colors
      'bg-gray-800',
      'text-white/80',

      // Shape
      'border-white/5',
      'shadow-md',

      // Size
      'max-h-[200px] overflow-auto'
    ]
  },
  list: {
    class: 'p-0 list-none m-0'
  },
  item: ({ context }) => ({
    class: [
      'relative',

      // Font
      'font-normal text-base leading-none',

      // Spacing
      'm-0 px-5 py-3',

      // Shape
      'border-t border-b first:border-t-none last:border-b-none',
      'rounded-none',

      // Colors
      {
        'text-white/80': !context.focused && !context.selected,
        'bg-primary-800/60': context.focused && !context.selected,
        'text-white/80': context.focused && !context.selected,

        'text-white/80': context.focused && context.selected,
        'bg-primary-800': context.focused && context.selected,
        'text-white/80': !context.focused && context.selected,
        'bg-primary-300': !context.focused && context.selected,
        'border-t-transparent border-b-black/25': context.disabled || !context.focused,
        'border-t-white/5 border-b-white/5': !context.disabled && context.focused,
      },

      //States
      { 'hover:bg-surface-600/80': !context.focused && !context.selected },
      { 'hover:text-white hover:bg-surface-600/80': context.focused && !context.selected },

      // Transition
      'transition-shadow duration-200',

      // Misc
      'cursor-pointer overflow-hidden whitespace-nowrap'
    ]
  }),
  itemgroup: {
    class: [
      'font-bold',

      // Spacing
      'm-0 p-3',

      // Colors
      'bg-surface-700',
      'text-white/80',

      // Misc
      'cursor-auto'
    ]
  },
  emptymessage: {
    class: [
      // Font
      'leading-none',

      // Spacing
      'py-3 px-5',

      // Color
      'text-white/80',
      'bg-transparent'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
